import {Filter, getFiltersWithoutPriceAndSort} from "../../getFiltersFromMerchandisedPath"
import {CATEGORY_FILTERS_REGEX, kidsGenderCategories, kidsGenders} from "../../../config/constants"

const findDuplicates = (arr: string[]) => arr.filter((item, index) => arr.indexOf(item) !== index)

// Takes a URL segment e.g. "colour-red-gender-women"
// returns false if the url segment contains duplicate filters (e.g. colour-red-colour-blue has duplicate "colour")
// returns true if the duplicate filter is a kids gender
export const indexMerchandiseURLFilters = (filters: string, merchandisedURLFilterDepthCount: number): boolean => {
    if (filters.includes("isort-") || filters.includes("minprice-")) return false
    const filtersArray = getFiltersWithoutPriceAndSort(filters)
    const nonIndexableFilters: Filter[] = []
    filtersArray.forEach(filter => {
        if (!kidsGenderCategories.includes(filter.filterValue)) nonIndexableFilters.push(filter)
    })
    const duplicates = findDuplicates(nonIndexableFilters.map(f => f.filterName))
    const uniqueKeys = [...new Set(nonIndexableFilters.map(f => f.filterName))]
    return duplicates.length === 0 && uniqueKeys.length < merchandisedURLFilterDepthCount
}

// Takes a URL segment e.g. "colour-red-gender-women"
// returns false if the url segment contains duplicate filters (e.g. colour-red-colour-blue has duplicate "colour")
export const indexFilters = (filters: string): boolean => {
    // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
    const filtersArray = filters.match(CATEGORY_FILTERS_REGEX) || []

    const keyArray: string[] = []
    filtersArray.forEach(filter => {
        const key: string = filter.split("-")[0]
        if (!kidsGenders.includes(filter)) keyArray.push(key)
    })
    const duplicates = findDuplicates(keyArray)
    return duplicates.length === 0
}

export default indexFilters
